import {get} from './httpApi';

/*注册短信发送*/
export function getByCode(data){
    return get('/dictionary/noJwt/getByCode',{
        ...data,
    })
}